( function( $, window, defaultCampus ) {
	'use strict';

	var $campusSectionSwitch;
	var $campusSwitch;
	var $campusSwitchInput;
	var $campusGroup;
	var $campusContent;
	var $campusStopEl;

	var resizeTimer;

	var activeClassName = 'is-active';
	var transitioningClassName = 'is-changing';
	var fixedClassName = 'is-sticky';
	var stoppedClassName = 'is-stopped';
	var fadeDuration = 400; // 400 = jquery default

	function changeCampus( campus ) {
		var chosenCampusSelector = '[data-campus="' + campus + '"]';

		// iterate through each group
		$campusGroup.each( function() {
			var $tabGroup = $( this );
			var $tabs = $tabGroup.children( $campusContent );

			var $newTab = $tabs.filter( chosenCampusSelector );
			var $oldTab = $tabs.not( chosenCampusSelector );

			// set height of group to visible tab's height
			$tabGroup.height( $oldTab.outerHeight() );

			// set height of group to that of the currently hidden tab
			$tabGroup.stop().animate( {
				height: $newTab.outerHeight()
			} );

			$newTab.addClass( transitioningClassName );

			// fade out visible tab
			$oldTab.fadeOut( fadeDuration, function() {
				$newTab.addClass( activeClassName );
				$oldTab.removeClass( activeClassName ).css( 'display', '' );
				$tabs.removeClass( transitioningClassName );

				// remove height from group
				$tabGroup.stop().css( 'height', '' );
				$campusSwitchInput.filter( '[value="' + campus + '"]' ).prop( 'checked', true );
			} );

		} );
	}

	function positionSwitch() {
		var campusSwitchOffset = $campusSectionSwitch.offset().top - 30;

		if ( $( window ).scrollTop() >= campusSwitchOffset ) {
			if ( $( window ).scrollTop() < $campusStopEl.offset().top - 30 - ( $campusSwitch.outerHeight() / 2 ) ) {
				$campusSwitch.addClass( fixedClassName ).removeClass( stoppedClassName ).css( {
					top: ''
				} );
			} else {
				$campusSwitch.addClass( stoppedClassName ).removeClass( fixedClassName ).css( {
					top: $campusStopEl.offset().top - $campusSectionSwitch.offset().top - ( $campusSwitch.outerHeight() / 2 )
				} );
			}
		} else {
			$campusSwitch.removeClass( 'is-sticky' );
		}
	}

	function registerScrollHandler() {
		$( window ).on( 'scroll', function() {
			positionSwitch();
		} );
	}

	function registerResizeHandler() {
		$( window ).on( 'resize', function() {
			clearTimeout( resizeTimer );
			resizeTimer = setTimeout( function() {
				positionSwitch();
			}, 250 );
		} );
	}

	function registerClickHandler() {
		$campusSwitchInput.on( 'change', function() {
			var campusSwitchTarget = $( this ).val();
			window.location.hash = '#campus-' + campusSwitchTarget;
			Cookies.set( 'campus', campusSwitchTarget );
		} );
	}

	function init() {
		if ( -1 !== window.location.hash.indexOf( '#campus-' ) ) {
			parseHash();
		}
		else if ( 'undefined' !== typeof Cookies.get( 'campus' ) ) {
			changeCampus( Cookies.get( 'campus' ) );
		} else if ( 'undefined' !== typeof defaultCampus ) {
			changeCampus( defaultCampus );
		}
	}

	function parseHash() {
		var hash = window.location.hash;

		if ( -1 !== hash.indexOf( '#campus-' ) ) {
			changeCampus( hash.replace( '#campus-', '' ) );
		}
	}

	function registerHashChangeHandler() {
		$( window ).on( 'hashchange', function() {
			parseHash();
		} );
	}

	$( function() {
		$campusSectionSwitch = $( '.js-campus-section-switch' );
		$campusSwitch = $( '.js-campus-switch' );
		$campusSwitchInput = $( '.js-campus-switch-input' );
		$campusGroup = $( '.js-campus-group' );
		$campusContent = $( '.js-campus-content' );
		$campusStopEl = $( '.js-campus-stop' );

		if ( $campusSectionSwitch.length ) {
			init();
			registerClickHandler();
			registerScrollHandler();
			registerResizeHandler();
			registerHashChangeHandler();
			positionSwitch();
			parseHash();
		}
	} );
} )( jQuery, window, defaultCampus );
